import { API, AUTH_HEADER, ROUTES } from "@/api";

export const state = {
  enforceAuthorization: null,
  enforceAuthorizationLoaded: false,
};

export const getters = {
  isEnforcePendingAuthorizationEnabled(state) {
    if (state.enforceAuthorization === null) {
      return true;
    }
    return !!state.enforceAuthorization;
  },
  enforceAuthorizationLoaded(state) {
    return state.enforceAuthorizationLoaded;
  },
};

export const mutations = {
  SET_ENFORCE_AUTHORIZATION(state, enforce) {
    state.enforceAuthorization = !!enforce;
    state.enforceAuthorizationLoaded = true;
  },
  RESET_ENFORCE_AUTHORIZATION(state) {
    state.enforceAuthorization = null;
    state.enforceAuthorizationLoaded = false;
  },
};

function defaultEnforceFromEnv() {
  const value = process.env.VUE_APP_ENFORCE_PENDING_AUTHORIZATION;
  if (value === undefined || value === null || value === "") {
    return true;
  }
  return String(value).toLowerCase() === "true";
}

export const actions = {
  async fetchEnforceAuthorization({ commit }) {
    const url = `${ROUTES.department}/enforce-authorization/status`;
    try {
      const res = await API.get(url, { headers: AUTH_HEADER() });
      commit("SET_ENFORCE_AUTHORIZATION", res.data?.enforce);
      return res.data;
    } catch {
      commit("SET_ENFORCE_AUTHORIZATION", defaultEnforceFromEnv());
      return { enforce: defaultEnforceFromEnv() };
    }
  },

  resetEnforceAuthorization({ commit }) {
    commit("RESET_ENFORCE_AUTHORIZATION");
  },

  async updateEnforceAuthorization({ commit }, enforce) {
    const url = `${ROUTES.department}/enforce-authorization`;
    const res = await API.put(
      url,
      { enforce: !!enforce },
      { headers: AUTH_HEADER() }
    );
    commit("SET_ENFORCE_AUTHORIZATION", res.data?.enforce);
    return res.data;
  },
};
